import clsx from 'clsx';
import { Money } from 'components/Money';
import { useMerchant } from 'hooks/context/merchant';
import React, { ReactElement } from 'react';

export type MerchantCurrencyProps<E extends HTMLElement = HTMLSpanElement> = React.HTMLProps<E> & {
  tagName?: keyof React.ReactHTML;
  placeholder?: string;
  amount?: number;
  disablePlaceholder?: boolean;
  locale?: string;
}

export function MerchantCurrency<E extends HTMLElement = HTMLSpanElement>(props: MerchantCurrencyProps<E>): ReactElement | null {
  const { isLoading } = useMerchant();

  if (props.amount && isLoading) {
    const { tagName, amount, placeholder, disablePlaceholder, ...spreadable } = props;

    return React.createElement(tagName ?? 'span', {
      ...spreadable,
      className: clsx('shimmer', props.className)
    }, props.children);
  }

  return <Money {...props} />;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
type MerchantCurrency<E extends HTMLElement = HTMLSpanElement> = React.FC<MerchantCurrencyProps<E>>;

// eslint-disable-next-line
MerchantCurrency.defaultProps = Money.defaultProps;
